import { api } from '../utils/api';
export const ReportApi = {    
    
    getReportAuthToken: async (): Promise<string> => {
        return await api.get(`Report/AuthToken`);
    },
};